module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account_download"
  }, [_c('div', {
    staticClass: "account_download__title"
  }, [_vm._v("PURCHASED DOWNLOADS")]), _vm._v(" "), _vm._l((3), function(i) {
    return _c('div', {
      key: i,
      staticClass: "bg-white rounded-10px account_download__item",
      class: _vm.$vuetify.breakpoint.width <= 650 ? 'wrap' : ''
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-center mr-3 wrap",
      class: _vm.$vuetify.breakpoint.width <= 1280 ? 'gap-18' : 'gap-36'
    }, [_c('div', {
      staticClass: "cursor-pointer text-poppins-15"
    }, [_vm._v("Download")]), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-13"
    }, [_vm._v("3 remaining")])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex gap-14"
  }, [_c('div', {
    staticClass: "account_download__image"
  }, [_c('img')]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "text-poppins-15 font-weight-600"
  }, [_vm._v("\n          I Thought We Were Having Fun\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-15 text-grey-1"
  }, [_vm._v("RUCKAZOID, Tri Nohbi")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dc48e72","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/components/account_download.vue
// module id = 1670
// module chunks = 180